import Socket from '../connection/socket';
import store from '../stores/main';
import { handleConditionalAction } from '../utils/sync';
import { SyncedActionMessage } from '../utils/sync-constants';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { RequestSyncedState } from '../connection/sync';

const fireSyncedAction = async (message: SyncedActionMessage) => {
	const clientSession = store.getState().SessionReducer?.session;

	// this is an action we've fired ourselves, has gone through beehive, and we heard it over socket
	// SET_PRESENTED_MEDIA_VIDEOSTATE, gets to fire anyways
	// because beehive may have mutated this state, and
	// we want to apply the changes beehive inserted.
	if (
		clientSession === message.session
		&& message.action.type !== 'SET_PRESENTED_MEDIA_VIDEOSTATE'
		&& message.action.type !== 'SET_PRESENTED_MEDIA'
	) {
		return;
	}

	const actionToFire = await handleConditionalAction(message);

	if (actionToFire) {
		socketListenerDispatch({ ...actionToFire, remote: true });
	}
};

const handleSyncStateUpdate = () => {
	const {
		SessionReducer: {
			token,
			meeting,
		},
	} = getState();

	RequestSyncedState(meeting.meeting, token);
};

export default function Sync(socket: Socket) {
	if (!socket.isEnablerView) {
		socket.addListener('synced-redux-action', fireSyncedAction);
		socket.addListener('meeting-sync-update', handleSyncStateUpdate);
	}
}
